module.exports = __webpack_public_path__ + "img/elec-lab.ac54d2b4.jpg";